var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenderMen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.769531 36.1538C0.769531 35 1.0003 32.6154 1.53876 31.6923C2.23107 30.5385 3.69261 29.3846 4.69261 28.9231L8.53876 27",
    stroke: "#2E63EE",
    strokeWidth: 1.53846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1572 36.1563C36.1572 35.0024 35.9264 32.6178 35.3879 31.6948C34.6956 30.5409 33.2341 29.3871 32.2341 28.9255L29.0898 27.2148",
    stroke: "#2E63EE",
    strokeWidth: 1.53846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1572 36.1535L11.0802 24.2305L8.46484 26.9228V36.1535",
    stroke: "#2E63EE",
    strokeWidth: 1.53846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.96 36.1535L26.037 24.2305L28.6523 26.9228V36.1535",
    stroke: "#2E63EE",
    strokeWidth: 1.53846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3098 8.00391C27.3098 8.23468 27.3098 8.54237 27.2329 8.77314C27.2329 9.08083 27.079 10.2347 26.8483 11.4654C27.6175 11.5424 28.2329 12.1578 28.3098 12.8501V12.927C28.3098 13.0039 28.3098 13.0808 28.3098 13.1578V13.2347C28.3098 13.6962 28.156 14.4654 28.079 14.8501C28.0021 15.0808 27.9252 15.4654 27.8483 15.8501C27.6944 16.2347 27.6175 16.6193 27.5406 16.7731C27.2329 17.4654 26.4636 17.7731 25.6944 17.6193C25.5406 18.1578 25.3867 18.6193 25.3867 18.6193C24.9252 20.1578 24.0021 21.3885 22.6944 22.3116C21.3867 23.3885 19.8483 24.0808 18.3867 24.0808C17.0021 24.0808 15.3098 23.3116 14.079 22.3116C12.7713 21.3885 11.8483 20.0808 11.3867 18.6193C11.3867 18.6193 11.3098 18.2347 11.079 17.6193C10.9252 17.6193 10.7713 17.6962 10.6944 17.6962C10.079 17.6962 9.54057 17.3885 9.23287 16.8501C9.07903 16.4654 8.69441 15.3116 8.61749 14.927C8.54057 14.5424 8.38672 13.8501 8.38672 13.3116V13.2347C8.38672 13.1578 8.38672 13.0808 8.38672 13.0039V12.927C8.46364 12.2347 9.07903 11.6193 9.84826 11.5424C9.69441 10.3116 9.54057 9.15775 9.46364 8.85006C9.46364 8.61929 9.38672 8.3116 9.38672 8.08083",
    stroke: "#2E63EE",
    strokeWidth: 1.53846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8483 0.769531C23.8483 0.769531 21.0021 0.769531 18.4636 0.769531H18.3867C16.5406 0.769531 14.8483 1.07722 13.6944 1.69261C11.1559 2.76953 9.38672 5.23107 9.38672 8.07722",
    stroke: "#00C9B8",
    strokeWidth: 1.53846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6926 8.46364C23.3849 7.54056 22.5388 6.92518 21.5388 6.92518H16.9234C15.9234 6.92518 15.0772 6.3098 14.7695 5.38672",
    stroke: "#00C9B8",
    strokeWidth: 1.53846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9258 3.46484C25.5412 4.15715 27.3104 5.92638 27.3104 8.0033",
    stroke: "#00C9B8",
    strokeWidth: 1.53846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenderMen);
export default __webpack_public_path__ + "static/media/Gender_Men.e46cafa4b388b1312038ef76c513ffd4.svg";
export { ForwardRef as ReactComponent };